import React, {useState, useRef, useEffect } from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css/zoom';
import { Zoom } from 'swiper/modules';
import {getBaseImagePath} from "../Utils";
import ModelImageInterface from "../../../interfaces/model/ModelImageInterface";
import {convertImageToSize, ImageSize} from "../../../utils/Image";

interface CardMobilePopupProps {
    isOpen: boolean;
    onClose: () => void;
    initialSlideIndex: number;
    images: ModelImageInterface[];
    altString: string;
}

const CardMobilePopup: React.FC<CardMobilePopupProps> = ({isOpen, onClose, initialSlideIndex, images, altString}) => {
    const [slideIndex, setSlideIndex] = useState<number>(initialSlideIndex);
    const swiperRef = useRef<any>(null);


	useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
        if (isOpen) {
            // Блокировка перехода назад
            window.history.pushState(null, '', window.location.href);
        }
    };

    if (isOpen) {
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', handlePopState);
    }

    return () => {
        window.removeEventListener('popstate', handlePopState);
    };
}, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal fade modal-card-mobile-popup show" style={{display: "block"}}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="modal-feedback__wrap">
                            <div className="modal-feedback__title">
                                <button type="button" className="close" onClick={onClose}></button>
                            </div>
                            <div className="card-mobile-popup__slider-wrapper">
                                <Swiper
									modules={[Zoom]} 
                                    initialSlide={initialSlideIndex}
									zoom={true}
                                    onSlideChange={(swiper: any) => setSlideIndex(swiper.activeIndex)}
                                    onSwiper={(swiper: any) => {
                                        swiperRef.current = swiper;
                                    }}
                                >
                                    {images.map((image, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="swiper-zoom-container">
                                                <img
                                                    src={getBaseImagePath() + convertImageToSize(image, ImageSize.ORIIGINAL).url}
                                                    alt={`${altString} - ${index + 1}`}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            {/* <div className="card-mobile-popup__controls">
                <button className="slick-btn slick-btn-prev" onClick={() => {
                  swiperRef.current.slidePrev();
                  setSlideIndex(slideIndex > 0 ? slideIndex - 1 : images.length - 1);
                }}></button>
                <button className="slick-btn slick-btn-next" onClick={() => {
                  swiperRef.current.slideNext();
                  setSlideIndex(slideIndex < images.length - 1 ? slideIndex + 1 : 0);
                }}></button>
              </div> */}
                            <div className="card-mobile-popup__thumbnail-slider">
                                {images.map((image, index) => (
                                    <div
                                        key={index}
                                        className="thumbnail"
                                        style={{border: slideIndex === index ? "1px solid black" : "none"}}
                                        onClick={() => {
                                            swiperRef.current.slideTo(index);
                                            setSlideIndex(index);
                                        }}
                                    >
                                        <img src={getBaseImagePath() + image.url} alt={`Thumbnail ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardMobilePopup;
